export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_DEFAULT_4.7177bb84.jpg";